import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getData } from '../Services/api';
import Pagination from '../Services/Pagination';

const CallLog = () => {
  const [calls, setCalls] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const { id } = useParams();

  const fetchCalls = async () => {
    try {
      const params = new URLSearchParams({
        page,
        search,
        userId: id,
        ...(dateFrom && { from: dateFrom }),
        ...(dateTo && { to: dateTo + 'T23:59:59' }),
      }).toString();

      const res = await getData(`/calls/call-log-get-using-id?${params}`);
      if (res.success) {
        setCalls(res.calls || []);
        setPage(res.currentPage || 1);
        setPages(res.totalPages || 0);
        setTotal(res.totalRecords || 0);
      }
    } catch (error) {
      console.log('Error fetching calls:', error);
    }
  };

  useEffect(() => {
    fetchCalls();
  }, [page, search, dateFrom, dateTo]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber !== page) {
      setPage(pageNumber);
    }
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  const handleDateFromChange = (e) => {
    setDateFrom(e.target.value);
    setPage(1);
  };

  const handleDateToChange = (e) => {
    setDateTo(e.target.value);
    setPage(1);
  };

  const handleClearDates = () => {
    setDateFrom('');
    setDateTo('');
    setPage(1);
  };

  return (
    <>
      <div className="pc-container">
        <div className="pc-content">
          <div className="page-header">
            <div className="page-block">
              <div className="row align-items-center">
                <div className="col-md-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item" aria-current="page">
                      Call Log
                    </li>
                  </ul>
                </div>
                <div className="col-md-12">
                  <div className="page-header-title">
                    <h2 className="mb-0">Call Log</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Date Filters */}
          <div className="row mb-3 px-4 align-items-end">
            <div className="col-md-3">
              <label className="form-label mb-1"><strong>From Date</strong></label>
              <input
                type="date"
                className="form-control"
                value={dateFrom}
                onChange={handleDateFromChange}
              />
            </div>
            <div className="col-md-3">
              <label className="form-label mb-1"><strong>To Date</strong></label>
              <input
                type="date"
                className="form-control"
                value={dateTo}
                onChange={handleDateToChange}
              />
            </div>
            <div className="col-md-2">
              <button
                className="btn btn-outline-secondary"
                onClick={handleClearDates}
              >
                Clear
              </button>
            </div>
          </div>

          {/* Table */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card table-card">
                <div className="card-body">
                  <div className="d-sm-flex align-items-center p-4">
                    <ul className="list-inline me-auto my-1">
                      <li className="list-inline-item">
                        <div className="form-search">
                          <i className="fas fa-search" />
                          <input
                            type="search"
                            className="form-control"
                            placeholder="Search calls"
                            value={search}
                            onChange={handleSearchChange}
                          />
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div className="table-responsive">
                    <table className="table table-hover" id="pc-dt-simple">
                      <thead>
                        <tr>
                          <th>S.No.</th>
                          <th>Name</th>
                          <th>Call To</th>
                          <th>Connect Status</th>
                          <th>Duration (sec)</th>
                          <th>Called At</th>
                        </tr>
                      </thead>
                      <tbody>
                        {calls?.length > 0 ? (
                          calls.map((call, index) => (
                            <tr key={call.id}>
                              <td>{index + 1 + (page - 1) * 10}</td>
                              <td>{call.displayName || 'Unknown'}</td>
                              <td>{call.call_to}</td>
                              <td>{call.connectStatus}</td>
                              <td>{call.durationSeconds}</td>
                              <td>
                                {new Date(call.calledAt).toLocaleString("en-GB", {
                                  timeZone: "Africa/Dar_es_Salaam",
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  second: "2-digit"
                                })}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td className="text-center" colSpan={6}>
                              <strong>No Calls Found.</strong>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  <div className="d-flex justify-content-between align-items-center px-4 pb-3">
                    <div className="text-muted">
                      Showing {total === 0 ? 0 : (page - 1) * 10 + 1} to{' '}
                      {Math.min(page * 10, total)} of {total} entries
                    </div>
                    <Pagination
                      page={page}
                      pages={pages}
                      onPageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CallLog;